<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    append-to-body
    width="400px"
    class="createTag"
  >
    <div class="input-div">
      <el-input v-model="tagInfo.TAGNAME" placeholder="请输入名称" class="tag-input">
        <i
          slot="prefix"
          :style="getColor(tagInfo.COLOR)"
          class="el-input__icon el-icon-s-opportunity"
        ></i>
      </el-input>
      <el-button type="primary" @click="createTag">{{title}}</el-button>
    </div>
    <div class="color-panel">
      <el-button
        v-for="(item,index) in colorArray"
        :key="index"
        circle
        icon="el-icon-check"
        class="color-div"
        :style="getBackground(item)"
        @click="changeColor(item)"
      ></el-button>
    </div>
    <div style="margin-top:10px;margin-left:5px">
      <el-checkbox v-model="tagInfo.MyDefault">设为我的常用标签</el-checkbox>
    </div>
  </el-dialog>
</template>
//创建标签
<script>
import { AddTag, EditTag } from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  props: {
    editTag: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    editTag(newValue) {
      if (newValue) {
        console.log(newValue);
        this.title = "保存";
        this.dialogTitle = "编辑标签";
        this.tagInfo = newValue;
      } else {
        this.title = "创建";
        this.dialogTitle = "创建新标签";
        this.tagInfo = { TAGNAME: "", COLOR: "#22d7bb", MyDefault: false };
      }
    }
  },
  data() {
    return {
      title: "创建",
      dialogTitle: "创建新标签",
      dialogVisible: false,
      showColorList: false,
      tagInfo: { TAGNAME: "", COLOR: "#22d7bb", MyDefault: false },
      colorArray: [
        { color: "#22d7bb", isSelect: true },
        { color: "#18bfa4", isSelect: false },
        { color: "#2cccda", isSelect: false },
        { color: "#2dbcff", isSelect: false },
        { color: "#4e8af9", isSelect: false },
        { color: "#7076fa", isSelect: false },
        { color: "#9473fd", isSelect: false },
        { color: "#c472ee", isSelect: false },
        { color: "#ef7ede", isSelect: false },
        { color: "#f969aa", isSelect: false },
        { color: "#fa5a55", isSelect: false },
        { color: "#ff7747", isSelect: false },
        { color: "#ffa415", isSelect: false },
        { color: "#ffd234", isSelect: false },
        { color: "#99d75a", isSelect: false },
        { color: "#66c060", isSelect: false },
        { color: "#39ba5d", isSelect: false }
      ]
    };
  },
  methods: {
    changeColor(item) {
      console.log("changeColor");
      this.tagInfo.COLOR = item.color;
      this.colorArray.forEach(o => (o.isSelect = false));
      item.isSelect = true;
    },
    createTag() {
      if (this.tagInfo.TAGNAME.length == 0) {
        this.$message.warning("请输入标签名称");
      }
      this.tagInfo = Object.assign(this.tagInfo, {
        CREATEUSERID: cookieUser.userId,
        CREATEUSERNAME: cookieUser.realName,
        CREATEDEPTID: cookieUser.departmentId,
        CREATEDEPTNAME: cookieUser.departmentName,
        CREATECOMPANYID: cookieUser.companyId,
        CREATECOMPANYNAME: cookieUser.companyName
      });
      console.log(this.tagInfo);
      var promise = null;
      if (this.tagInfo.ID) {
        promise = EditTag(this.tagInfo);
      } else {
        promise = AddTag(this.tagInfo);
      }
      promise
        .then(result => {
          if (result.ResultCode > 0) {
            this.$message.success("保存成功");
            this.dialogVisible = false;
            this.$emit("success");
          } else {
            this.$message.error(result.MsgInfo);
          }
        })
        .finally(() => {
          this.tagInfo = { NAME: "", COLOR: "#22d7bb", MyDefault: false };
        });
    },
    getBackground(item) {
      if (item.isSelect) {
        return `background:${item.color}; color:#fff;`;
      } else {
        return `background:${item.color}; color:${item.color};`;
      }
    },
    getColor(color) {
      return `color:${color}; font-size:26px`;
    }
  }
};
</script>
<style scoped>
.color-panel button {
  padding: 7px !important;
}
</style>
<style lang="scss" scoped>
.input-div {
  display: flex;
}

.color-div {
  cursor: pointer;
}
.color-panel {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  button {
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 5px;
    border: 0;
    //   text-align: center;
  }
}
</style>